export const orgAccessLevel = Object.freeze({
    developer: [1, 33, 111], //Developer
    admin: [33, 111],
    owner: [111]
})